import { render, staticRenderFns } from "./inviteSettingDialogNew.vue?vue&type=template&id=2d1b3633&scoped=true"
import script from "./inviteSettingDialogNew.vue?vue&type=script&lang=js"
export * from "./inviteSettingDialogNew.vue?vue&type=script&lang=js"
import style0 from "./inviteSettingDialogNew.vue?vue&type=style&index=0&id=2d1b3633&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1b3633",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1b3633')) {
      api.createRecord('2d1b3633', component.options)
    } else {
      api.reload('2d1b3633', component.options)
    }
    module.hot.accept("./inviteSettingDialogNew.vue?vue&type=template&id=2d1b3633&scoped=true", function () {
      api.rerender('2d1b3633', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/sepecialOrderPrint/components/inviteSettingDialogNew.vue"
export default component.exports